module.exports = __webpack_public_path__ + "img/11.24cff246.png";